module.exports = __webpack_public_path__ + "static/media/29BDOS20.f9647361.jpg";